// Session storage — non-sensitive UI data only.
// isAdmin authority comes from the JWT access token (via apiFetch), NOT from localStorage.
// The access token itself lives in memory (apiFetch.js) to prevent XSS theft.

/**
 * Persist display-only data after login.
 * userId is kept so pages can still reference it without a token decode.
 */
export function setSession(userId, username, ageGroup, owlletId, isTeacher, displayName) {
  localStorage.setItem('userId',    String(userId));
  localStorage.setItem('username',  username);
  localStorage.setItem('ageGroup',  ageGroup || 'below_16');
  if (owlletId) localStorage.setItem('owlletId', owlletId);
  localStorage.setItem('isTeacher', isTeacher ? '1' : '0');
  if (displayName) localStorage.setItem('displayName', displayName);
  else localStorage.removeItem('displayName');
}

/**
 * Returns { userId, username, ageGroup, owlletId } if session data exists,
 * otherwise null.
 */
export function getSession() {
  const userId   = localStorage.getItem('userId');
  const username = localStorage.getItem('username');
  if (!userId) return null;
  return {
    userId,
    username,
    ageGroup:  localStorage.getItem('ageGroup') || 'below_16',
    owlletId:  localStorage.getItem('owlletId') || null,
    // isAdmin/isTeacher kept for legacy pages that read it; authoritative value is in JWT
    isAdmin:   localStorage.getItem('isAdmin')   === '1',
    isTeacher: localStorage.getItem('isTeacher') === '1',
  };
}

/** Wipe localStorage on sign-out. */
export function clearSession() {
  ['userId', 'username', 'displayName', 'ageGroup', 'owlletId', 'isAdmin', 'isTeacher', 'rq_theme', 'difficulty_tier'].forEach(k => localStorage.removeItem(k));
}
